<i class="m-r-xs dot" *ngIf="(!showAttentionDoctor && isOnAntibioticOrTab)"></i><a class="btn btn-primary-outline btn-xs" *ngIf="showAttentionDoctor && isOnAntibioticOrTab" style="background-color: red; font-weight: bold;">Attn Doctor</a>
